import { render, staticRenderFns } from "./NotesInput.vue?vue&type=template&id=cf1a18f0"
import script from "./NotesInput.vue?vue&type=script&lang=ts"
export * from "./NotesInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports